import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { ExamesDispositivosModel } from "./exames-dispositivos.model";
import { ExamesDispositivosService } from './exames-dispositivos.service';
import { Funcoes } from "../../funcoes";
import { Global } from "../../global";

@Component({
  selector: 'app-exames-dispositivos-form',
  templateUrl: './exames-dispositivos-form.component.html'
})
export class ExamesDispositivosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  dispositivo: ExamesDispositivosModel = new ExamesDispositivosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private examesDispositivosService: ExamesDispositivosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]],
      numero_serie: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(50)
      ]]
    });
  }

  ngOnInit() {
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    this.route.params.subscribe(params => {
      var id = params['id_dispositivo'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarDispositivo');
      } else {
        this.title = id ? this.func.traduzir('front.editarDispositivo') : this.func.traduzir('front.cadastrarNovoDispositivo');
      }

      if (this.pageIsAdd) {
        this.title = this.func.traduzir('front.cadastrarNovoDispositivo');
      }

      if (!id) {
        return;
      }

      this.examesDispositivosService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarDispositivo') + ': ' + json.Payload[0].nome;
            } else {
              this.title = this.func.traduzir('front.visualizarDispositivo') + ': ' + json.Payload[0].nome;
            }

            this.dispositivo = json.Payload[0];

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.nome) {
      values.nome = values.nome.toUpperCase();
    }
    if (values.numero_serie) {
      values.numero_serie = values.numero_serie.toUpperCase();
    }

    if (values.id) {
      result = this.examesDispositivosService.editar(values, values.id);
    } else {
      result = this.examesDispositivosService.adicionar(values);
    }

    result.subscribe(
      data => this.router.navigate(['/painel', 'exames', 'dispositivos']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/exames/dispositivos/exames-dispositivos-form.component.ts